import React, { useState, useRef, useEffect } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { connectSearchBox } from 'react-instantsearch-dom'

const SearchBox = ({ delay, refine, currentRefinement }) => {
  const [value, setValue] = useState(currentRefinement)
  const inputRef = useRef({})

  useEffect(() => {
    inputRef?.current?.focus()
  }, [])

  const handleChange = (value) => {
    debounceRefine(value)
    setValue(value)
  }

  const debounceRefine = useDebouncedCallback((value) => {
    refine(value)
  }, delay)

  return (
    <input
      ref={inputRef}
      type='search'
      className='ais-SearchBox-input'
      placeholder='Search here...'
      onChange={(event) => handleChange(event.target.value)}
      value={value}
    />
  )
}

const DebouncedSearchBox = connectSearchBox(SearchBox)

export default DebouncedSearchBox
